<template>
	<div class="m foot clearfix">
		<div class="foot_list clearfix">
			<div class="foot_menu">
				<router-link to="/m/index">
					<i class="icons i1"></i>
					<p>首&emsp;页</p>
				</router-link>
			</div>
			<div class="foot_menu">
				<div @click='gop'>
				<router-link to="/m/product">
					<i class="icons i2"></i>
					<p>产&emsp;品</p>
				</router-link>
				</div>
			</div>
			<div class="foot_menu">
				<a href='tel:021-52366166'>
					<i class="icons i3"></i>
					<p>热&emsp;线</p>
				</a>
			</div>
			<div class="foot_menu">
				<router-link to="/m/leavemsg">
				<i class="icons i4"></i>
				<p>留&emsp;言</p>
				</router-link>
			</div>
			<div class="foot_menu">
				<router-link to="/m/our">
					<i class="icons i5"></i>
					<p>我&emsp;们</p>
				</router-link>
			</div>
		</div>

	</div>
</template>
<script>
import wx from 'weixin-js-sdk'
	export default {
	  name: 'foot',
	  data(){
	  	return{
	  		
	  	}
	  },
	  watch:{
	  	'$route':function(){
	  		this.getconfig()
	  	}
	  },
	  mounted:function(){
	  	this.getconfig()
	  },
	  methods:{
	  	gop:function(){
	  		sessionStorage.setItem('id','1')
	  		//this.$router.push('/m/product')
	  		//http://dking.vapps.me/index.php?g=Index&m=Index&a=getconfig&ref='
	  	},
	  	getconfig(){
	  		this.$http.get(this.host+'/index.php?g=Index&m=Index&a=getconfig&ref=&ref='+encodeURIComponent(window.location.href.split('#')[0])).then(response => {
		         this.data=response.body.data
		         this.jssdk=response.body.apilist
		         console.log(response)
		         console.log(this.jssdk)
		         wx.config({
		          debug: false,
		          appId: this.jssdk.appid, // 和获取Ticke的必须一样------必填，公众号的唯一标识
		          timestamp:this.jssdk.timestamp, // 必填，生成签名的时间戳
		          nonceStr: this.jssdk.noncestr, // 必填，生成签名的随机串
		          signature: this.jssdk.str,// 必填，签名，见附录1
		          //需要分享的列表项:发送给朋友，分享到朋友圈，分享到QQ，分享到QQ空间
		          jsApiList: [
		           'onMenuShareAppMessage','onMenuShareTimeline'
		          ]
		        });
		    })
		    var that = this
		    wx.ready(function(){
		        wx.onMenuShareTimeline({
		            title: '帝景国际卫浴', // 分享标题
		            //link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
		            /*link:window.location.href+'?share=true',*/
		            imgUrl: this.host+'/static/images/logo.jpg', // 分享图标
		            success: function () { 
		               
		            },
		            cancel: function () { 
		                // 用户取消分享后执行的回调函数
		            }
		        });

		        wx.onMenuShareAppMessage({
		            title: '帝景国际卫浴', // 分享标题
		            desc: '帝景国际卫浴', // 分享描述
		            /*link:window.location.href+'?share=true',*/
		            //link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
		            imgUrl: this.host+'/static/images/logo.jpg', // 分享图标
		            type: '', // 分享类型,music、video或link，不填默认为link
		            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
		            success: function () { 
		                
		            },
		            cancel: function () { 
		                // 用户取消分享后执行的回调函数
		            }
		        });
		    });
	  	}
	  }
	  
	}
</script>
<style scoped>
	.m.foot{
		position: fixed;
		left: 0;
		bottom: 0;
		padding:0.13rem 0;
		width: 100%;
		background-color: #fff;
		z-index: 999;
		border-top: 1px solid #e0e0e0;
		left: 50%;
		transform: translateX(-50%);
	}
	.foot_menu{
		float: left;
		width: 20%;
		text-align: center;
		font-size: 0.18rem;
		color: #8e8e8e;
	}
	.m.foot .icons{
		display: inline-block;
		background-image: url(/static/images/m/m_icons.png);
		background-size:2.77rem 1.9rem; 
	}
	.icons.i1{
		width: 0.38rem; height: 0.35rem;
    	background-position:  -0.68rem -0.87rem;
	}
	.router-link-active .icons.i1{
		    width: 0.36rem;
    height: 0.34rem;
    background-position: -2.34rem -0.67rem;
	}
	.icons.i2{
		width: 0.38rem; height: 0.36rem;
        background-position:  -1.79rem -0.10rem;
	}
	.router-link-active .icons.i2{
		width: 0.34rem; height: 0.34rem;
    background-position:  -1.24rem -1.45rem;
	}
	.icons.i3{
		width: 0.38rem; height: 0.38rem;
        background-position:  -0.10rem -0.87rem;
	}

	.icons.i4{
		width: 0.37rem; height: 0.35rem;
        background-position:  -0.10rem -1.45rem;
	}
	.router-link-active .icons.i4{
		width: 0.37rem; height: 0.35rem;
    background-position:  -0.67rem -1.45rem;
	}
	.icons.i5{
		width: 0.32rem; height: 0.37rem;
        background-position:  -1.79rem -0.66rem;
	}
	.router-link-active .icons.i5{
		width: 0.32rem; height: 0.37rem;
    background-position:  -2.35rem -0.10rem;
	}
	.m.foot a p{
		color: #8e8e8e;
	}
	.m.foot .router-link-active p{
		color: #3478f7;
	}
</style>


// WEBPACK FOOTER //
// src/components/mobile/public/foot.vue